<li>
    <i class="icofont icofont-ui-rating"></i>
    <i class="icofont icofont-ui-rating"></i>
    <i class="icofont icofont-ui-rating"></i>
    <i class="icofont icofont-ui-rate-blank"></i>
    <i class="icofont icofont-ui-rate-blank"></i>
</li>